
<template>
  <div id="jinfmcourse">

    <!-- maim -->
    <main class="main">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><router-link to="/index">首頁</router-link></li>
            <li><router-link to="/channel/list">鯨選課程</router-link></li>
            <li>{{this.title}}</li>
          </ul>
        </div>
      </div>
      <CourseHead
        :title="title"
        :subtitle="subtitle"
        :calculation-episode="calculationEpisode"
        :collection-point="collectionPoint"
        :collection-view-point="collectionViewPoint"
        :single-episode-point="singleEpisodePoint"
        :added-time="addedTime"
        :page-url="pageUrl"
        :is-app-user-agent="isAppUserAgent"
        :qr-code-value="qrCodeValue"
        :img-cover="imgCover"
      />
      <div
        ref="bodyCourse"
        class="bodyContent"
      >
        <div class="container">
          <div ref="course_tabs" class="course_tabs">
            <ul>
              <li
                :class="{ 'tab_active': tabIndex === 1 }"
                @click= "tabIndex = 1"
              >課程簡介</li>
              <li
                :class="{ 'tab_active': tabIndex === 2 }"
                @click= "tabIndex = 2"
              >音頻列表</li>
            </ul>
          </div>
          <div v-show="tabIndex === 1" class="course_introduction">
            <CourseIntroduction
              :publisher="publisher"
              :purchase-info="purchaseInfo"
              :description="description"
              :audition-videos-list="auditionVideosList"
              :description-html="descriptionHtml"
              :author-img-avatar="authorImgAvatar"
              :author-title="authorTitle"
              :author-description="authorDescription"
              :author-channels="authorChannels"
            />
            <section
              v-show="related_channels_list.length !== 0"
              class="relatedCourse"
            >
              <h2>相關課程</h2>
              <div class="wrapper">
                <RelatedChannelsBanner :related-channels-list="related_channels_list"/>
              </div>
            </section>
          </div>
          <div v-show="tabIndex === 2" class="course_repertoire">
            <CourseRepertoire
              :channelID="channelID"
              :title="title"
              :author-title="authorTitle"
              :img-cover="imgCover"
              :episodes-list="episodesList"
              :pagination-class-data="paginationClassData"
              :current-page="currentPage"
              :total-pages="totalPages"
              v-on:change-list-page="changeListPage"
            />
          </div>
          <section class="qrcode_course">
            <div
              :class="{ 'wrapper_fixed': isQRcodeFixed }"
              class="wrapper"
            >
              <div class="box">
                <qrcode-vue :value="qrCodeValue" :size="125" level="H"></qrcode-vue>
                <figcaption>下載<b>一刻鯨選 App</b>收聽完整課程！</figcaption>
              </div>
            </div>
          </section>
        </div>
      </div>
      <AudioPlayer ref="aplayer" />
    </main>

  </div>
</template>

<script>
/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
import fancybox from '@/assets/vendor/fancybox-master/jquery.fancybox.min.js'

// import GLightbox from "glightbox";
// eslint-disable-next-line no-unused-vars
import slick from '@/assets/vendor/slick/slick.min.js'
// eslint-disable-next-line no-unused-vars
import readmore from '@/assets/vendor/readmore/readmore.min.js'
// eslint-disable-next-line no-unused-vars
import functionJs from '@/assets/js/function.js'
// eslint-disable-next-line no-unused-vars
import pace from '@/assets/vendor/pace/js/pace.min.js'

// let glightbox = require('@/assets/vendor/glightbox-master/glightbox.min.js')
import { mapState, mapActions } from 'vuex'
import CourseHead from './components/CourseHead'
import CourseIntroduction from './components/CourseIntroduction'
import CourseRepertoire from './components/CourseRepertoire'
import RelatedChannelsBanner from './components/RelatedChannelsBanner'
import AudioPlayer from '@/components/widget/AudioPlayer'
import QrcodeVue from 'qrcode.vue'
import { getClientAudioList } from '@/api/audio'
import { parseDate, parseTrackTime } from '@/utils/parseTime'
// import { cloneDeep as _cloneDeep } from 'lodash'

export default {
  name: 'course',
  metaInfo () {
    return {

      title: this.title + ' | 課程 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { vmid: 'og:title', name: 'title', property: 'og:title', content: this.title + '| 課程 | 一刻鯨選' },
        { vmid: 'og:site_name', name: 'site_name', property: 'og:site_name', content: this.title + '| 課程 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { vmid: 'og:type', name: 'type', property: 'og:type', content: 'article' },
        // Should the the same as your canonical link, see below.
        { vmid: 'og:url', name: 'url', property: 'og:url', content: window.location.toString() },
        { vmid: 'og:image', name: 'image', property: 'og:image', content: this.imgCover },
        // Often the same as your meta description, but not always.
        { vmid: 'og:description', name: 'description', property: 'og:description', content: this.meta_description }

      ]
      // link: [
      //   { rel: 'canonical', href: window.location.href }
      // ]
    }
  },

  afterRouteEnter  (to, from, next) {
    to.$forceUpdate()

    // react to route changes...
    next()
  },
  components: {
    CourseHead,
    CourseIntroduction,
    CourseRepertoire,
    QrcodeVue,
    RelatedChannelsBanner,
    AudioPlayer
  },
  data () {
    return {
      classData: {},
      title: '', // 標題
      subtitle: '', // 副標題
      imgCover: '', // 圖片
      purchaseInfo: '',
      description: '', // 描述
      meta_description: '', // 描述(meta用)

      descriptionHtml: '', // 描述HTML
      target: '', // 適合對象
      total: '', // 總課堂數
      publishedTime: '', // 出版時間，UTC時間
      episode_counts: '', // 音頻數量
      author: [], // 作者
      authorTitle: '', // 作者標題
      authorImgAvatar: '', // 作者圖片
      authorDescription: '', // 作者描述
      episodesList: [], // 音頻
      episodes_title: '', // 音頻標題
      episodes_summary: '', // 音頻大綱
      episodes_publishedTime: '', // 音頻出版時間，UTC時
      products: [],
      auditionVideosList: [], // 試聽影音
      related_channels_list: [], // 相關課程
      products_points: '', // 銷售方案點數
      publisher: '', // 出版方
      id: '0',
      channelID: '',
      shareURL: '',
      qrCodeValue: '',
      pageUrl: '',
      lineShareValue: '',
      QRcodeio: null,
      isQRcodeFixed: false,
      authorData: [],
      getAuthorChannels: [],
      authorChannels: [],
      isAppUserAgent: false,

      tabIndex: 1,
      api_current_page: 1,
      currentPage: 1,
      totalPages: 1,
      paginationClassData: []

    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile
    }),
    calculationEpisode () {
      let count = ''
      let countTotal = ''

      const episodesSerialize = this.classData.episodes_serialize
      const total = this.classData.total

      const slash = (episodesSerialize === false || total === 0) ? '' : '/'

      if (episodesSerialize === true) {
        count = `已連載 ${this.classData.episode_counts} 集`
      }
      if (total !== 0) {
        countTotal = `${total} 集`
      }
      return `${count} ${slash} ${countTotal}`
    },
    collectionProduct () {
      const collectionProductList = this.products.filter((product) => {
        return product.productType === 1
      })
      // console.log(collectionProductList);
      if (collectionProductList.length !== 0) {
        return collectionProductList[0]
      } else {
        return null
      }
    },
    collectionPoint () {
      const vm = this
      // console.log(vm.collectionProduct);
      return vm.collectionProduct === null ? '' : `${vm.collectionProduct.points} 點`
    },
    collectionViewPoint () {
      const vm = this
      // console.log(vm.collectionProduct);
      return vm.collectionProduct === null ? '' : `${vm.collectionProduct.view_points} 點`
    },
    singleEpisodePoint () {
      const singleEpisodeProduct = this.products.filter((product) => {
        return product.productType === 5
      })
      // console.log(singleEpisodeProduct);
      const verticalBar = singleEpisodeProduct.length === 0 || this.collectionPoint === '' ? '' : '|'

      if (singleEpisodeProduct.length !== 0) {
        return `${verticalBar} 每集 ${singleEpisodeProduct[0].points} 點`
      } else {
        return ''
      }
    },
    addedTime () {
      return parseDate(this.publishedTime)
    }
  },

  created () {
    var userAgent = navigator.userAgent
    if (userAgent.indexOf('jinfmapp') > -1) {
      this.isAppUserAgent = true
    }

    // this.QRCodeValue ='https://jinfm.page.link/?link='+window.location.toString()+'&apn=net.jinfm&isi=1374244242&ibi=net.jinfm&ius=jinfm&st=一刻鯨選&sd=好知識就在耳邊',
    this.pageUrl = window.location.toString()
    if (this.pageUrl.includes('?')) {
      this.pageUrl = this.pageUrl.split('?')[0]
    }

    this.qrCodeValue = 'https://jinfm.page.link/?link=' + this.pageUrl + '&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm'

    this.id = window.location.toString()
    this.shareURL = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.toString()

    var index = this.id.lastIndexOf('/')

    this.id = Number(this.id.substring(index + 1, this.id.length))

    this.channelID = window.location.pathname.replace('/channel/', '')
    this.getAudioList(this.channelID)
    this.axios
      .get(this.$store.getters.baseURL + 'channels/' + this.channelID)
      .then(response => {
        // 抓取精選大師取得全部作者
        this.axios
          .get(this.$store.getters.baseURL + 'authors?per_page=1000')
          .then(response => {
            this.authorData = response.data
            for (let i = 0; i < this.authorData.length; i++) {
              if (this.author.id === this.authorData[i].id) {
                this.getAuthorChannels.push(this.authorData[i].channels)
              }
            }

            this.getAuthorChannels = this.getAuthorChannels[0]
            const channelId = Number(this.channelID)
            // 當頁課程不需加入
            for (let i = 0; i < this.getAuthorChannels.length; i++) {
              if (channelId !== this.getAuthorChannels[i].id) {
                this.authorChannels.push(this.getAuthorChannels[i])
              }
            }

            //    this.classData = this.stortData(response.data.data.purchase_count);
          })
          .catch((error) => {
            console.log('errorLog:' + error)
            this.$router.push('/')
          })
        this.classData = response.data
        this.imgCover = this.classData.imgCover
        this.total = this.classData.total
        this.publishedTime = this.classData.publishedTime
        this.author = this.classData.author
        this.episode_counts = this.classData.episode_counts
        this.author = this.classData.author
        this.authorImgAvatar = this.author.imgAvatar
        this.auditionVideosList = this.classData.audition_videos
        this.related_channels_list = this.classData.related_channels
        this.products = this.classData.products

        if (this.classData.products.length === 0) {
          this.products_points = '免費'
        } else {
          this.products_points = this.classData.products[0].points + '點'
        }
        this.getTW()
        this.meta_description = this.strip_html_tags(this.meta_description)
        this.lineShareValue = '【一刻鯨選】' + this.title + '\n' + ''

        // ga
        if (this.title !== '') {
          this.$ga.page({
            page: '/channel/' + this.channelID,
            title: this.title + ' | 課程 | 一刻鯨選',
            location: window.location.href
          })
        }
      })
      .catch((error) => {
        console.log('errorLog:' + error)
        this.$router.push('/')
      })
  },
  updated () {},
  methods: {
    ...mapActions('audio', [
      'setAudioList',
      'setCourseInfo',
      'setTrackInfo'
    ]),
    strip_html_tags (str) {
      if ((str === null) || (str === '')) { return false } else { str = str.toString() }
      return str.replace(/<[^>]*>/g, '')
    },
    changePage (page) {
      this.$router.push({ path: '/' + page })
    },
    getTW () {
      this.title = this.classData.title
      this.subtitle = this.classData.subtitle
      this.purchaseInfo = this.classData.purchaseInfo
      this.description = this.classData.description
      this.meta_description = this.classData.description
      this.descriptionHtml = this.classData.descriptionHtml
      this.target = this.classData.target
      this.authorTitle = this.author.title
      this.authorDescription = this.author.descriptionHtml
      this.publisher = this.classData.publisher
    },
    getCN () {
      this.title = this.classData.titleCN
      this.subtitle = this.classData.subtitleCN
      this.description = this.classData.descriptionCN
      this.meta_description = this.classData.descriptionCN
      this.descriptionHtml = this.classData.descriptionHtmlCN
      this.target = this.classData.targetCN
      this.authorTitle = this.author.titleCN
      this.authorDescription = this.author.descriptionHtmlCN
      this.publisher = this.classData.publisherCN
    },
    async getAudioList (channelId) {
      const vm = this
      getClientAudioList(channelId)
        .then((res) => {
          // console.log(res)
          vm.episodesList = res.data.data.map((episode, index) => {
            const { publishedTime, timeLength } = episode
            episode.updated_at = parseDate(publishedTime)
            episode.timeLength = parseTrackTime(timeLength)
            episode.num = index < 9 ? `0${index + 1}` : `${index + 1}`

            return episode
          })
          // console.log(vm.episodesList)

          this.sortClass(vm.episodesList, 'add')
        })
    },
    // 重排課程列表
    sortClass (classData, type) {
      // console.log(classData, type);
      let allCount
      if (type === 'add') {
        this.paginationClassData = []
        allCount = classData.length
        this.totalPages = Math.ceil(classData.length / 10)
        // console.log(this.totalPages)

        let size = classData.length
        if (classData.length > 10) {
          size = 10
        }
        for (let i = 0; i < size; i++) {
          this.paginationClassData.push(classData[i])
        }
      } else {
        if (this.api_current_page !== this.currentPage) {
          this.paginationClassData = []
          allCount = classData.length

          let i = (this.currentPage - 1) * 10

          if (allCount > this.currentPage * 10) {
            allCount = this.currentPage * 10
          }

          for (i; i < allCount; i++) {
            this.paginationClassData.push(classData[i])
          }

          this.api_current_page = this.currentPage
          this.scrollToList()
        }
      }
    },
    // 接收子層currentPage後重排課程列表
    changeListPage (val) {
      this.currentPage = val
      this.sortClass(this.episodesList, 'update')
    },
    scrollToList () {
      // console.log(this.$refs.bodyCourse.offsetTop)
      window.scrollTo({
        top: this.$refs.bodyCourse.offsetTop - 128,
        left: 0,
        behavior: 'smooth'
      })
    }
  },
  mounted () {
    $('body').removeClass('index')

    $('.moreOrLess').readmore({
      moreLink: '<a class="readMore" href="#">顯示更多</a>',
      lessLink: '<a href="#">顯示更少</a>',
      collapsedHeight: 600,
      afterToggle: function (trigger, element, expanded) {
        if (!expanded) {
          // The "Close" link was clicked
          $('html, body').animate(
            { scrollTop: element.offset().top },
            { duration: 100 }
          )
        }
      }
    })

    $('article').readmore({ speed: 1000 })

    this.QRcodeio = new IntersectionObserver(
      (entries) => {
        // 如果不可见，就返回
        // console.log(entries)
        if (!entries[0].isIntersecting) {
          this.isQRcodeFixed = true
        } else {
          this.isQRcodeFixed = false
        }
      },
      {
        threshold: [0.25]
      })

    this.QRcodeio.observe(this.$refs.course_tabs)
  },
  beforeDestroy () {
    if (this.QRcodeio) {
      this.QRcodeio.unobserve(this.$refs.course_tabs)
    }
  }
}
</script>
<style lang="scss" scoped>

@media screen and (min-width: 768px) {
  .bodyContent {
    padding: 60px 0;
  }
}

.course_tabs {
  border-bottom: 1px solid #E6E6E6;
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;
  margin-bottom: 24px;
  ul {
    align-items: center;
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: flex-start;
    margin-bottom: 0px;
    *:not(:last-child) {
      margin-right: 2rem
    }
    li {
      font-weight: 500;
      font-size: 24px;
      line-height: 25px;
      padding-bottom: 10px;
      cursor: pointer;
    }
    .tab_active {
      color: #176E8D;
      border-bottom: 4px solid #176E8D;
    }
  }
}

.qrcode_course .wrapper {
  position: absolute;
  top: 0;
}
.qrcode_course .wrapper_fixed {
  position: fixed;
  top: 135px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Course/index.vue